module.exports = __webpack_public_path__ + "img/btn_plus.b1cb4896.svg";